import React from 'react'

import { useRecipe, useStockHook } from '../../model/context'
import {
  AlignItems,
  Box,
  Color,
  Display,
  DisplayPosition,
  JustifyContent,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'

const OverlayDiv = withCitrusTheme(Box, () => ({
  position: DisplayPosition.Absolute,
  top: 0,
  left: '0',
  height: '100%',
  width: '100%',
  opacity: 0.7,
  zIndex: '11',
  display: Display.Flex,
  justifyContent: JustifyContent.Center,
  alignItems: AlignItems.Center,
  paddingV: 0,
  paddingH: 3,
}))

export function SoldOutOverlay({ backgroundColor = Color.White }: { backgroundColor?: Color }) {
  const useStock = useStockHook()
  const { isRecipeOutOfStock } = useStock()
  const { id: recipeId } = useRecipe()

  if (!recipeId) {
    return null
  }

  const isOutOfStock = isRecipeOutOfStock(recipeId)

  if (!isOutOfStock) {
    return null
  }

  return <OverlayDiv id="overlayDiv" bg={backgroundColor} />
}
